import { ApiDataSource } from '../utils/api-data-source';

/**
 * Datasource for the System Banners admin list.
 *
 * Adds a status filter on top of the standard ApiDataSource behaviour.
 * When `status` is null the filter is omitted so the API returns all banners.
 */
export class SystemBannersListDataSource extends ApiDataSource {

  order_by = 'sort_order';
  order = 'asc';

  /**
   * Optional status filter. One of: 'draft', 'published', 'archived', or null (All).
   */
  status: string | null = null;

  getData(resetOffset: boolean = false) {
    const params: any = {};
    if ( this.status ) {
      params.status = this.status;
    }
    return this.makeRequest(`v2/admin/system-banners`, resetOffset, params);
  }
}
